import { ExpandCircleDown } from '@mui/icons-material'
import { Button, type SxProps, type Theme } from '@mui/material'
import { useThingsToConsider } from '../../../../hooks/use-thingsToConsider'
import { ThingsToConsiderCard, type ThingsToConsiderSection } from './ThingsToConsiderCard'
import { useRef } from 'react'

interface Props {
  buttonDataTestId?: string
  thingsToConsiderSections: ThingsToConsiderSection[]
  cardSx?: SxProps<Theme>
  cardDataTestId?: string
}
export const ThingsToConsiderButton = (props: Props): JSX.Element => {
  const { showThingsToConsiderCard, handleThingsToConsider } = useThingsToConsider()
  const buttonRef = useRef<HTMLButtonElement>(null)

  const thingsToConsiderCardTopPosition = `${(buttonRef.current?.offsetTop ?? 0) + (buttonRef.current?.offsetHeight ?? 0) + 5}px`

  return <>
    <Button
      ref={buttonRef}
      data-testid={props.buttonDataTestId ?? 'thingsToConsiderButton'}
      sx={{ backgroundColor: 'var(--white)', color: 'var(--blue-700)', padding: '10px 24px' }}
      onClick={handleThingsToConsider}
    >
      Things to Consider
      <ExpandCircleDown
        sx={{
          ml: '10px',
          color: 'var(--grey-700)',
          transform: showThingsToConsiderCard ? 'rotate(180deg)' : '',
          transition: 'transform 300ms ease-in-out'
        }}
        fontSize='small'
      />
    </Button>

    {showThingsToConsiderCard &&
      <ThingsToConsiderCard
        sections={props.thingsToConsiderSections}
        sx={{ ...props.cardSx, top: thingsToConsiderCardTopPosition, right: 0 }}
        dataTestId={props.cardDataTestId}
      />}
  </>
}
